import { Component,EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_RADIO_DEFAULT_OPTIONS } from '@angular/material/radio';
import { OpsProduct, ProductSegment, ProductSearchParam, Counter, FGProductId, Product } from '../../../Models/product';
import { ProductProfitablity, SpraAmcvTotalValue, SpraConsigneeData } from 'src/app/Models/ops';
import { MasterService } from '../../../Services/master.service';
import { TaxApiParam } from '../../../Models/tax';
import { TransactionService } from '../../../Services/transaction.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { ContactConsigneeParams } from 'src/app/Models/master';
import { SpraConsigneeComponent } from '../spra-consignee/spra-consignee.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-ops-part-serach',
  templateUrl: './ops-part-serach.component.html',
  styleUrls: ['./ops-part-serach.component.css']
})
export class OpsPartSerachComponent implements OnInit {
  @Output("ChangeOpsPartSerach") ChangeOpsPartSerach: EventEmitter<any> = new EventEmitter();
  @Output("ChangeCounterList") ChangeCounterList: EventEmitter<any> = new EventEmitter();
  @Output("ProductValueChanged") ProductValueChanged: EventEmitter<any> = new EventEmitter(); 
  @Output("GetFGProduct") GetFGProduct: EventEmitter<any> = new EventEmitter();  
  @Output("SpraHaveFinishGood") SpraHaveFinishGood: EventEmitter<any> = new EventEmitter(); 
  @Output("Consignee") Consignee: EventEmitter<any> = new EventEmitter();  

  @ViewChild(SpraConsigneeComponent) SpraConsigneeComponent!: SpraConsigneeComponent;
  RefId:number;
  OpportunityId:number;
  IsTaxApplicable:boolean=true;
  
  IsRental:boolean = false;
  taxApiParam:TaxApiParam;
  Mode:string;                      // "I" New Insertion, "U" Update, "V" validation
  productArray: Array<OpsProduct> = [];
  FGProdParam: Array<OpsProduct>=[];
  ProductSearchParam :ProductSearchParam;
  spraAmcvTotalValue:SpraAmcvTotalValue; 
  AdvanceGroupId:string="1";
  ProductSegmentList: any[]= [];
  ProductGradeList: any[]= [];
  ProductCodes: any[] = [];
  productsForConsignee:any[] = [];
  utility: Utility;
  SaleType:string;
  ProfitTag:boolean;
  IsDayOneCSAClick:boolean;   //Added Bby Jamaluddin Ansari on 22/08/2023
  ReviewedSpra:boolean=false;
  GradeId:string="1";
  ProductProfitablity:ProductProfitablity;
  // TotalQty:number;
  // TotalPrice:number;
  // TotalSaleValue:number;  
  // TotalPriceList:number;
  // TotalWSNSP:number;
  // TotalLandedCost:number;
  // TotalBookLC:number;
  // TotalFinishedGoodsPrice:number;
  // GPPriceList:string;
  // GPWSNSP:string;
  // GPLandedCost:string;
  // GPBookLC:string;
  ProductCodesForCounter:string="";
  // TotalFGServSaleValue:number;  
  // TotalFGServPriceList:number;
  // TotalFGServWSNSP:number;
  // TotalFGServLandedCost:number;
  // TotalFGServBookLC:number;
  // FGServGPPriceList:string;
  // FGServGPWSNSP:string;
  // FGServGPLandedCost:string;
  // FGServGPBookLC:string;
  // TotCostAmount :number;
  // TotSaleAmount :number;
  // TotLoanAmount :number;
  // TotDiscount:number;
  // ProfitBeforeTax:number;
  // ProfitBeforeTaxWithInt:number;
  spraConsigneeData:Array<SpraConsigneeData>;
  
  constructor(
    private _MasterService: MasterService,
    private _TransactionService:TransactionService, 
      private _NotificationService:NotificationService,
      private _CookieService: CookieService,
      private dialog: MatDialog,
    ) {
      this.utility = new Utility(this._CookieService);
      this.RefId = 0;
      this.OpportunityId = 0 //Added By Sagar Pandey For DD/DL cases Date:21-12-2023
    this.Mode = "I";
    this.SaleType = "";
    this.ProfitTag=false;
    this.IsDayOneCSAClick=false;
    this.ProductProfitablity = new ProductProfitablity();
    // this.TotalQty=0;
    // this.TotalPrice=0;
    // this.TotalSaleValue=0;
    // this.TotalPriceList=0;
    // this.TotalWSNSP=0;
    // this.TotalBookLC=0;
    // this.TotalLandedCost=0;
    // this.GPPriceList="0";
    // this.GPWSNSP="0";
    // this.GPLandedCost="0";
    // this.GPBookLC="0";
    // this.TotalFinishedGoodsPrice= 0;
    this.taxApiParam = new TaxApiParam();
    this.ProductSearchParam=  new ProductSearchParam();
    this.productArray.push(new OpsProduct());
    // this.TotalFGServSaleValue=0;  
    // this.TotalFGServPriceList=0;
    // this.TotalFGServWSNSP=0;
    // this.TotalFGServLandedCost=0;
    // this.TotalFGServBookLC=0;
    // this.FGServGPPriceList="";
    // this.FGServGPWSNSP="";
    // this.FGServGPLandedCost="";
    // this.FGServGPBookLC="";
    // this.TotCostAmount =0;
    // this.TotSaleAmount=0;
    this.spraAmcvTotalValue =new SpraAmcvTotalValue();
    // this.TotLoanAmount=0;
    // this.TotDiscount=0;
    // this.ProfitBeforeTax=0;
    // this.ProfitBeforeTaxWithInt=0;
    this.spraConsigneeData =  new Array<SpraConsigneeData>();
  }

  ngOnInit(): void {
    
  
  }


  addRow(product: OpsProduct) {    
    product.IsNewRow = true;
    let newProduct: OpsProduct = new OpsProduct();
    this.productArray.push(newProduct);
    return true;
  }

  deleteRow(index: number) {   
    debugger
        // this.TriggerProductModelChange();    
    if (this.productArray.length == 1) {
      return false;
    } else {
      let DeletedProduct:any=this.productArray[index].SelectedProduct
        // Changed by rajan singh on 28 sep 2021 -->> (if admin delete any product from spra -- same product should be remove from consignee detail instead of all)
        // this.spraConsigneeData = [];

        if(DeletedProduct!= undefined) //Conditon added by Sagar Pandey If DeleteProduct has no productid then skip it and delete the row only
        {
          this.spraConsigneeData.forEach(cd=>{          
            cd.ProductDetails = cd.ProductDetails.filter(pd=> {return pd.ProductId != DeletedProduct.productId});
          });
        }
       


      this.productArray.splice(index, 1);
      if(this.productArray.length == 1){
        this.ProductCodesForCounter = "";
      }

      /*--if condiciton added by rajan singh on 17/06/2021 -- to not refresh counters if deleted product is not FG*/
      if(DeletedProduct != undefined &&  DeletedProduct.productGroupId == 1){
       this.GetDistinctProductCounter();
      }
      

       if(this.ProfitTag==true)
        {
          this.CalculateTotalValue();
        }
        this.GetFinishedGoodsTotalPrice();
        
      return true;
    }
   
   
    
  }

  ProductModelChange(product: OpsProduct,index:number){
        this.ProductCodesForCounter = "";    
    if(product.SelectedProduct != null && product.SelectedProduct != undefined){
    
      // --Check for duplicate product --
    if(this.productArray.filter(function(item:OpsProduct){
        return item.SelectedProduct?.productId == product.SelectedProduct.productId
      }).length>1){
          alert("Can not select the duplicate pruduct");
          product.SelectedProduct = null;
      };

      // && this.Mode == "I"
      if((index+1) == this.productArray.length){
      this.addRow(product);
      }
     
   
      this.GetProductNationalStock(product);
      // this.GetTax(product);
      //added bys wati on 07/04/2021
      if(this.Mode != "I")
      {
        this.GetSPRAPriceListData(product,0,this.SaleType);
        if(this.ProfitTag==true)
        {
          this.CalculateTotalValue();
        }
      }      
      //end of addition by swati
     
      /*--GETTING DISTINCT COUNTER LIST OF ENTERED PRODUCT AS NEEDED FOR CREATE AMCV FORM--*/
      /*--if condiciton added by rajan singh on 17/06/2021 -- to not refresh counters if selected product is not FG*/
      if(product.SelectedProduct.productGroupId == 1){
        this.GetDistinctProductCounter();
      }
      
    }else{
      this.ChangeCounterList.emit([]);
    } 
    
  }


  GetDistinctProductCounter(){
        this.ProductCodesForCounter = "";

    //  Removed by rajan singh on 17/06/2021 -- after discussion with Mr. anand 
    // if (this.SaleType != "LL"){

      /*--CONCATINATING THE ALL ENTERED PRODUCT CODES NEED TO CALL API TO GET ALLDISTINCT COUNTER LIST--*/
      this.productArray.forEach(element => {
        if(element.SelectedProduct != undefined){
        if(this.ProductCodesForCounter ==""){
          this.ProductCodesForCounter = element.SelectedProduct.productCode  //.replace(" ","");
        }else{
          this.ProductCodesForCounter += "~" + element.SelectedProduct.productCode //.replace(" ","");
        }
      }        
      });
      if(this.ProductCodesForCounter.length>=3){
       this._MasterService.GetDistinctProductCounter(this.ProductCodesForCounter).toPromise().then((d):any =>{
          if(d){
             this.ChangeCounterList.emit(d)
          }
          });
        
      }else{
        this.ChangeCounterList.emit([]);
      }
      
      
    // }
    
  }

  GetProductNationalStock(product: OpsProduct){
    this._MasterService.GetProductNationalStock(product.SelectedProduct.productId , parseInt(this.GradeId)).subscribe((d):any =>{
      if(d){
        let data:any = d;
         product.SelectedProduct.stock = data.stock;
         //product.SelectedProduct.grade = "G1";
        product.SelectedProduct.gradeId = parseInt(this.GradeId);
      }
      
    });

  }

  GetSPRAPriceListData(product: OpsProduct, CounterID:number, SaleType: string){
    debugger
    this._MasterService.GetSPRAPriceListData(product.SelectedProduct.productId,CounterID,SaleType,0).then((d):any =>{
      if(d){        
        let data: any =JSON.parse(d.toString());
        product.SelectedProduct.PriceList =  data.PriceList;
        product.SelectedProduct.WorkSheetNSP = data.WorkSheetNSP;
        product.SelectedProduct.WorkSheetLanded = data.WorkSheetLanded;
        product.SelectedProduct.BookingLanded = data.BookingLanded;        
        product.PriceList = data.PriceList;
        product.BookingLanded = data.BookingLanded;
        product.WorkSheetLanded= data.WorkSheetLanded;
        product.WorkSheetNSP = data.WorkSheetNSP;
       //  CHANGED BY RAJAN SINGH ON 24 JUNE 2021 -- AFTER DISCUSSION WITH MR ANAND -- ALL PROFIT CALCULATION WILL BE BASED ON THE LANDED COST INSTEAD OF NET SALE PRICE
       //  product.UnitWSCost=data.WorkSheetNSP;
       product.UnitWSCost = data.WorkSheetLanded      
       this.CalculateTotalPrice(product);
      }
      
    });

  }

  CalculateTotalPrice(product:OpsProduct,ReverseSelectedProductPriceLis:boolean=false){
    debugger;
    // Added by Jamaluddin Ansari on 21/08/2023
    //IS Rental => YES
    if (this.IsRental == true && product.SelectedProduct && product.SelectedProduct.productGroupId == 4 &&
      (this.SaleType == "DD" || this.SaleType == "DL")) {

      product.PriceList = 0;
      product.BookingLanded = 0;
      product.WorkSheetLanded = 0;
      product.WorkSheetNSP = 0;
      product.UnitWSCost = 0;
      product.UnitSalePrice = 0;
      product.SaleAmount = 0;
      product.CostAmount = 0;
    }
    //IS Rental => NO
    else if (this.IsRental == false && this.IsDayOneCSAClick == true && product.SelectedProduct && product.SelectedProduct.productGroupId == 4 &&
      (this.SaleType == "DD" || this.SaleType == "DL")) {

      product.PriceList = 0;
      product.BookingLanded = 0;
      product.WorkSheetLanded = 0;
      product.WorkSheetNSP = 0;
    }
    if(ReverseSelectedProductPriceLis
        && product.PriceList != undefined
        && product.WorkSheetNSP != undefined
        && product.WorkSheetLanded != undefined
        && product.BookingLanded != undefined)
      {
                product.SelectedProduct.PriceList = this.utility.RoundOff(product.PriceList/product.Quantity);
        product.SelectedProduct.WorkSheetNSP = this.utility.RoundOff(product.WorkSheetNSP/product.Quantity);
        product.SelectedProduct.WorkSheetLanded = this.utility.RoundOff(product.WorkSheetLanded/product.Quantity);
        product.SelectedProduct.BookingLanded = this.utility.RoundOff(product.BookingLanded/product.Quantity);
    }
    if (this.utility.CheckNumberRequired(product.Quantity) && product.SelectedProduct != undefined && product.SelectedProduct.PriceList != undefined) {
      if (!this.IsRental) {
        product.PriceList = this.utility.RoundOff(product.Quantity * product.SelectedProduct.PriceList);
        product.BookingLanded = this.utility.RoundOff(product.Quantity * product.SelectedProduct.BookingLanded);
        product.WorkSheetLanded = this.utility.RoundOff(product.Quantity * product.SelectedProduct.WorkSheetLanded);
        product.WorkSheetNSP = this.utility.RoundOff(product.Quantity * product.SelectedProduct.WorkSheetNSP);
        //IS Rental => NO (When existing ProductCode is edited to solve issue of Consumable case Price) 10/11/2023
        if (this.IsRental == false && this.IsDayOneCSAClick == true && product.SelectedProduct && product.SelectedProduct.productGroupId == 4 &&
          (this.SaleType == "DD" || this.SaleType == "DL")) {

          product.PriceList = 0;
          product.BookingLanded = 0;
          product.WorkSheetLanded = 0;
          product.WorkSheetNSP = 0;
        }
      } else {
        product.PriceList = this.utility.RoundOff(product.SelectedProduct.PriceList);
        product.BookingLanded = this.utility.RoundOff(product.SelectedProduct.BookingLanded);
        product.WorkSheetLanded = this.utility.RoundOff(product.SelectedProduct.WorkSheetLanded);
        product.WorkSheetNSP = this.utility.RoundOff(product.SelectedProduct.WorkSheetNSP);

        //IS Rental => YES  (When existing ProductCode is edited to solve issue of Consumable case Price) 10/11/2023
        if (this.IsRental == true && product.SelectedProduct && product.SelectedProduct.productGroupId == 4 &&
          (this.SaleType == "DD" || this.SaleType == "DL")) {

          product.PriceList = 0;
          product.BookingLanded = 0;
          product.WorkSheetLanded = 0;
          product.WorkSheetNSP = 0;
          product.UnitWSCost = 0;
          product.UnitSalePrice = 0;
          product.SaleAmount = 0;
          product.CostAmount = 0;
        }

        //  CHANGED BY RAJAN SINGH ON 24 JUNE 2021 -- AFTER DISCUSSION WITH MR ANAND -- ALL PROFIT CALCULATION WILL BE BASED ON THE LANDED COST INSTEAD OF NET SALE PRICE
        if (product.WorkSheetLanded != undefined) {
           product.CostAmount = this.utility.RoundOff(product.WorkSheetLanded*product.Quantity);
            product.UnitWSCost = product.WorkSheetLanded;
        }
      }
    }
  }


  TriggerProductModelChange() {
    
    this.productArray.forEach((opsproduct: OpsProduct, index: number) => {
          this.ProductModelChange(opsproduct, index);
    })
  }



  onClear(product: OpsProduct) {
        this.spraConsigneeData = [];
    this.TriggerProductModelChange();
  }


  BindProductSegment() {

    this._MasterService.GetAllProductCategory(false).subscribe((d) => {  //false added by rahul yadav on 27/05/2021 in case of all product segment
      this.ProductSegmentList = [];
      this.ProductSegmentList.push({ "prodSegmentId": 0, "prodSegmentCode": "", "prodSegmentDesc": "-- Select --" });
      this.ProductSegmentList = this.ProductSegmentList.concat(d);
    });
  }

  BindGrade(){
    this._MasterService.GetQAStatus().subscribe((d) => {  
      this.ProductGradeList = [];
     // this.ProductGradeList.push({ "QAId": 0, "QADesc": "-- Select --" });
       this.ProductGradeList = this.ProductGradeList.concat(d);   
   });
  }



  onProductCodeKeypress(event: any, product: OpsProduct, index: number) {
    if (event.key != "ArrowDown" && event.key != "ArrowUp") {
      if (event.target.value.length > 2) {
        this.ProductCodes=[];
      this.ProductSearchParam.ProdSegmentId = parseInt(this.ProductSearchParam.ProdSegmentId.toString());
      if(this.IsRental){
        this.AdvanceGroupId = "1";
      }      

      // ADDED BY RAJAN SINGH ON 10 AUG 2021 -->> IN CASE OF BO EXECUTIVE ENTERING spra FOR DD/DL -->> FG SHOULD NOT BE VISIBLE
      //Added OpportunityId check by Sagar Pandey on Date 21-12-2023 If OpportunityId > 0 it means hit came from open enquiry list and in this case ProductGroupId can't be -1
      if(this.utility.user.officeId >1 && this.SaleType != 'LL' && this.OpportunityId == 0){
        this.ProductSearchParam.ProductGroupId  = -1;
      }else{
        this.ProductSearchParam.ProductGroupId  = 0;
      }


      this.ProductSearchParam.AdvanceGroupId = parseInt(this.AdvanceGroupId);
      this.ProductSearchParam.ProductCode = event.target.value;
      this.ProductSearchParam.ProductId = 0;
      this.ProductSearchParam.FGProductId = this.productArray.filter(function (item: OpsProduct) {
        return item.SelectedProduct?.productGroupId == 1
      }).map(mp => {
        let _FGProductId:FGProductId =  new FGProductId();
        _FGProductId.ProductId =  mp.SelectedProduct?.productId
        return _FGProductId;
      });

      this.BindProductAutocomplete(product,index);
    }else{
      this.ProductCodes = [];
    }
  }
  }
//Added by rahul yadav in case on 12/7/2021 
  ChangeProductGrade(){
    
    this.productArray.forEach((opsproduct: OpsProduct, index: number) => {
      if(opsproduct.SelectedProduct.productId != undefined){
        this.GetProductNationalStock(opsproduct)
      }
    })
  }

async BindProductAutocomplete(product: OpsProduct,index:number,IsBindingToPopulateInUpdateMode:boolean = false){
  debugger;
  //Commented by Jamaluddin Ansari for populating Product Code on DayOneCSA check/uncheck
  // this.ProductCodes=[];
  await this._MasterService.GetAllProductCode(this.ProductSearchParam).toPromise().then((d) => {
    if(d){
    let _ProductCodes:any[]=[];
    _ProductCodes  = _ProductCodes.concat(d);
  this.ProductCodes = this.ProductCodes.concat(_ProductCodes);
  if(_ProductCodes.length ==1){
    product.SelectedProduct = _ProductCodes[0];
    this.productArray[index] = product;
    if(!IsBindingToPopulateInUpdateMode){      
      this.ProductModelChange(product,index);
    }else{
      this.CalculateTotalPrice(product,true);
     this.SpraHaveFinishGood.emit(this.GetFinishedGoodsTag());
    }
    this.GetProductNationalStock(product);
       //added bys wati on 07/04/2021
       if((this.Mode != 'I') && (!IsBindingToPopulateInUpdateMode)){
       this.GetSPRAPriceListData(product,0,this.SaleType);
       setTimeout(() => {
        if(this.ProfitTag==true)
        {
          this.CalculateTotalValue();
        }
       });
      }
      
       //end of addition by swati
  }

}
});    
} 


Validation():boolean{

  if(!this.utility.CheckNumberRequired(this.ProductSearchParam.ProdSegmentId)){
    this._NotificationService.showError("Please select product segment","Ops Part Search");
    return false
  }

  let _ProductDetails = new Array<string>();
  let IsProductValid:boolean = true;
  this.productArray.forEach(element => {

    if (element.SelectedProduct != undefined && element.SelectedProduct.productId >0 && IsProductValid == true){
      if(!element.SelectedProduct.hsncode){
        this._NotificationService.showError("Product '"+ element.SelectedProduct.productCode +"' does not have HSN.","Ops Part Search");
        IsProductValid = false;
      }else if(element.Quantity <=0){
        this._NotificationService.showError("Product '"+ element.SelectedProduct.productCode +"' Quantity can not be 0.","Ops Part Search");
        IsProductValid = false;
      }
      else if(element.Price <=0 && !this.IsRental){
        this._NotificationService.showError("Product '"+ element.SelectedProduct.productCode +"' price can not be 0.","Ops Part Search");
        IsProductValid = false;
      }else{
          _ProductDetails.push(element.SelectedProduct.productCode);
      }
    }
  });    

  if(!IsProductValid){
    return false;
  }else if(_ProductDetails.length<=0){
    this._NotificationService.showError("Please enter at least on product detail","Ops Part Search");
    return false
  }


  let IsSpraHaveFinishGood:Boolean=this.GetFinishedGoodsTag();  
  let TotalProductQtySum:number = this.productArray.map(mt=> mt.Quantity).reduce((sum, current) => sum + current, 0);
  let TotalConsigneeProductQtySum:number = this.spraConsigneeData.map((cd)=> 
                                                {return  {Qty :cd.ProductDetails.map(mt=> parseInt(mt.Quantity)).reduce((sum, current) => sum + current, 0)}}
                                          ).map(mt=> mt.Qty).reduce((sum, current) => sum + current, 0);
   
//Added By rahul yadav on 31/05/2021
  if(!IsSpraHaveFinishGood && this.IsRental){
    this._NotificationService.showError("Please select atleast one finished good.","Consignee Detail");
    return false;  
  }
 else if (//IsSpraHaveFinishGood && //(this.SaleType == 'DD' || this.SaleType == 'DL') commented by rahul yadav in for mandatory consignee in all type
    this.spraConsigneeData.length <= 0){
    this._NotificationService.showError("Please enter Consignee Detail.","Consignee Detail");
    return false;    
  }else if (//IsSpraHaveFinishGood && //(this.SaleType == 'DD' || this.SaleType == 'DL') commented by rahul yadav in for mandatory consignee in all type
    TotalProductQtySum != TotalConsigneeProductQtySum){
    this._NotificationService.showError("Total product quantity is not equal to total Consignee product quantity .","Consignee Detail");
    return false;   
  }else{
    return true;
  }

  

}




  // GetTax(product: OpsProduct){

  //   if(this.IsTaxApplicable){
  //   this.taxApiParam.mintProductSegmentId = this.ProductSearchParam.ProdSegmentId;
  //   let productXml = "<root>";
  //   productXml += "<data>";
  //   productXml += "<ProductGroupId>"+ product.SelectedProduct.productGroupId +"</ProductGroupId>";
  //   productXml += "<ProductId>"+ product.ProductId +"</ProductId>";
  //   productXml += "<Quantity>" + product.Quantity + "</Quantity>";
  //   productXml += "<Rate>"+ product.Price +"</Rate>";
  //   productXml += "<HsnCode>" + product.SelectedProduct.hsncode + "</HsnCode>";
  //   productXml += "</data>";
  //   productXml += "</root>";

  //   if(this.taxApiParam.mintProductSegmentId >0 && product.SelectedProduct.productId >0
  //       && product.Quantity >0 && product.Price >0)   {
  //         this.taxApiParam.xmlData = productXml;
  //         this._TransactionService.GetOpsTax(this.taxApiParam).subscribe(d=>{
  //           if(d){
  //           let data:any = d;
  //           data = JSON.parse(data);
  //           if (!(data.d == null || data.d == "")) {
  //             var response = data.d.split("~");
  //             product.SelectedProduct.taxHtml = response[0];
  //             product.SelectedProduct.taxValue = parseFloat(response[1]);
  //           }
            
  //         }

            
  //         });

  //   }
    
  // }


  // }



  ChangeProductSegment(){    
    this.ChangeOpsPartSerach.emit(this.ProductSearchParam)
    this.ResetProductList();  
  }

  ResetProductList(){
    this.productArray = [];
    this.productArray.push(new OpsProduct());
  }

  CalculateTotalValue() {
    debugger;
    this.GetFinishedGoodsTotalPrice();
    // this.ProductProfitablity = new ProductProfitablity();
    this.ProductProfitablity.TotalQty = 0;
    this.ProductProfitablity.TotalPrice = 0;
    this.ProductProfitablity.TotalSaleValue = 0;
    this.ProductProfitablity.TotalPriceList = 0;
    this.ProductProfitablity.TotalWSNSP = 0;
    this.ProductProfitablity.TotalLandedCost = 0;
    this.ProductProfitablity.TotalBookLC = 0;
    this.ProductProfitablity.GPPriceList = "0";
    this.ProductProfitablity.GPWSNSP = "0";
    this.ProductProfitablity.GPLandedCost = "0";
    this.ProductProfitablity.GPBookLC = "0";
    this.ProductProfitablity.TotCostAmount=0;
    this.FGProdParam = [];
    // this.productArray.forEach(element => {
    //   
    //   this.CalculateTotalPrice(element);
    //   this.ProductProfitablity.TotCostAmount= this.ProductProfitablity.TotCostAmount + (element.UnitWSCost* element.Quantity);
    // });
    // setTimeout(() => {



this.ProductProfitablity.TotCostAmount = this.productArray.map(mt=> (mt.UnitWSCost*mt.Quantity)).reduce((sum, current) => sum + current, 0);
this.productArray.forEach((element,index) => {      
this.CalculateTotalPrice(element);
// this.ProductProfitablity.TotCostAmount= this.ProductProfitablity.TotCostAmount + (element.UnitWSCost* element.Quantity);


// if (element.gID == "G1") {
//   this.FGProdParam.push(element);
// }
  if (element.SelectedProduct != undefined && element.SelectedProduct.productGroupId == 1) {
    this.FGProdParam.push(element);
  }

  if (!this.IsRental) {
    this.ProductProfitablity.TotalQty =this.ProductProfitablity.TotalQty + Number(element.Quantity);
    this.ProductProfitablity.TotalPrice = this.ProductProfitablity.TotalPrice + Number(element.Price);
    this.ProductProfitablity.TotalSaleValue = this.ProductProfitablity.TotalSaleValue + (Number(element.Quantity) * Number(element.Price));
    if (element.PriceList != undefined) {
      this.ProductProfitablity.TotalPriceList = this.ProductProfitablity.TotalPriceList + element.PriceList;
    }
    if (element.WorkSheetNSP != undefined) {
      this.ProductProfitablity.TotalWSNSP = this.ProductProfitablity.TotalWSNSP + element.WorkSheetNSP;
    }
    if (element.WorkSheetLanded != undefined) {
      this.ProductProfitablity.TotalLandedCost = this.ProductProfitablity.TotalLandedCost + element.WorkSheetLanded;
    }
    if (element.BookingLanded != undefined) {
      this.ProductProfitablity.TotalBookLC = this.ProductProfitablity.TotalBookLC + element.BookingLanded;
    }


  } else {
    if(this.ProductProfitablity.TotCostAmount>0 &&  element.Quantity>0)
        {
      element.SaleAmount=(this.ProductProfitablity.TotLoanAmount * (element.UnitWSCost* element.Quantity))/this.ProductProfitablity.TotCostAmount;
      element.UnitSalePrice=(element.SaleAmount/ element.Quantity);
    }
         

      }

      // Added by Jamaluddin Ansari on 26/09/2023 For Adding  Product Code Consumable Case
      //IS Rental => YES
  if (this.IsRental == true && element.SelectedProduct && element.SelectedProduct.productGroupId == 4 &&
    (this.SaleType == "DD" || this.SaleType == "DL")) {
    element.UnitWSCost = 0;
    element.UnitSalePrice = 0;
    element.SaleAmount = 0;
    element.CostAmount = 0;
  }
      //IS Rental => NO
      else if (this.IsRental == false && this.IsDayOneCSAClick == true && element.SelectedProduct && element.SelectedProduct.productGroupId == 4 &&
    (this.SaleType == "DD" || this.SaleType == "DL")) {

    element.PriceList = 0;
    element.BookingLanded = 0;
    element.WorkSheetLanded = 0;
    element.WorkSheetNSP = 0;
  }

  if(index == this.productArray.length-1){
    this.GetFGProduct.emit(this.FGProdParam);
  }

}
);
    if (!this.IsRental) {
      this.ProductProfitablity.TotalSaleValue = this.ProductProfitablity.TotalSaleValue + this.ProductProfitablity.TotDiscount;
      if (this.ProductProfitablity.TotalSaleValue > 0) {
        this.ProductProfitablity.GPPriceList = (((this.ProductProfitablity.TotalSaleValue - this.ProductProfitablity.TotalPriceList) / (this.ProductProfitablity.TotalSaleValue)) * 100).toFixed(2) + "%";
        this.ProductProfitablity.GPWSNSP = (((this.ProductProfitablity.TotalSaleValue - this.ProductProfitablity.TotalWSNSP) / (this.ProductProfitablity.TotalSaleValue)) * 100).toFixed(2) + "%";
        this.ProductProfitablity.GPLandedCost = (((this.ProductProfitablity.TotalSaleValue - this.ProductProfitablity.TotalLandedCost) / (this.ProductProfitablity.TotalSaleValue)) * 100).toFixed(2) + "%";
        this.ProductProfitablity.GPBookLC = (((this.ProductProfitablity.TotalSaleValue - this.ProductProfitablity.TotalBookLC) / (this.ProductProfitablity.TotalSaleValue)) * 100).toFixed(2) + "%";
        // this.ProductProfitablity.GPPriceList = this.ProductProfitablity.GPPriceList;
        // this.ProductProfitablity.GPWSNSP = this.ProductProfitablity.GPWSNSP;
        // this.ProductProfitablity.GPLandedCost = this.ProductProfitablity.GPLandedCost;
        // this.ProductProfitablity.GPBookLC = this.ProductProfitablity.GPBookLC;

      }
    }

    // },500);
    // this.GetFGProduct.emit(this.FGProdParam);
  }

GetFinishedGoodsTag()
{
  if (this.productArray.filter(function (item: OpsProduct) {
    return item.SelectedProduct?.productGroupId == 1
  }).length > 0) {
    return true;
  } else {
    return false;
  }
}
GetSpraHaveCopMfdTag()
{
  if(this.utility.CopMFDSegment.indexOf(this.ProductSearchParam.ProdSegmentId) >=0){
    return true;
  }else{
    return false;
  }
}


GetFinishedGoodsTotalPrice()
{
  let TotalFinishedGoodsPrice:number = 0;
  let count:number = 0
  this.productArray.forEach((item) => {
    count = count+1;
    if(item.SelectedProduct != undefined && item.SelectedProduct.productGroupId == 1){
      TotalFinishedGoodsPrice += parseFloat((item.Quantity == undefined ?0:item.Quantity).toString())*parseFloat((item.Price == undefined ?0:item.Price).toString());
    }      
    if(this.productArray.length == count){
      this.ProductValueChanged.emit(TotalFinishedGoodsPrice);
    } 
  }); 

  

}

CalcFGServTotAmount()
{

  return new Promise((resolve,reject) =>{
  this.ProductProfitablity.TotalFGServSaleValue = this.spraAmcvTotalValue.TotSaleValue + this.ProductProfitablity.TotalSaleValue;
  this.ProductProfitablity.TotalFGServPriceList = this.spraAmcvTotalValue.TotPriceList + this.ProductProfitablity.TotalPriceList;
  this.ProductProfitablity.TotalFGServWSNSP = this.spraAmcvTotalValue.TotWorkSheetNSP + this.ProductProfitablity.TotalWSNSP;
  this.ProductProfitablity.TotalFGServLandedCost = this.spraAmcvTotalValue.TotWorkSheetLanded + this.ProductProfitablity.TotalLandedCost;
  this.ProductProfitablity.TotalFGServBookLC= this.spraAmcvTotalValue.TotBookingLanded + this.ProductProfitablity.TotalBookLC;
  if (this.ProductProfitablity.TotalFGServSaleValue >0){
    this.ProductProfitablity.FGServGPPriceList = ((( this.ProductProfitablity.TotalFGServSaleValue-this.ProductProfitablity.TotalFGServPriceList)/(this.ProductProfitablity.TotalFGServSaleValue))*100).toFixed(2) + "%";
    this.ProductProfitablity.FGServGPWSNSP = (((this.ProductProfitablity.TotalFGServSaleValue-this.ProductProfitablity.TotalFGServWSNSP)/( this.ProductProfitablity.TotalFGServSaleValue))*100).toFixed(2) + "%"
    this.ProductProfitablity.FGServGPLandedCost = (((this.ProductProfitablity.TotalFGServSaleValue-this.ProductProfitablity.TotalFGServLandedCost)/( this.ProductProfitablity.TotalFGServSaleValue))*100).toFixed(2) + "%"
    this.ProductProfitablity.FGServGPBookLC = (((this.ProductProfitablity.TotalFGServSaleValue-this.ProductProfitablity.TotalFGServBookLC)/( this.ProductProfitablity.TotalFGServSaleValue))*100).toFixed(2) + "%"
    
    // this.ProductProfitablity.FGServGPPriceList =   this.ProductProfitablity.FGServGPPriceList;
    // this.ProductProfitablity.FGServGPWSNSP =   this.ProductProfitablity.FGServGPWSNSP;
    // this.ProductProfitablity.FGServGPLandedCost =   this.ProductProfitablity.FGServGPLandedCost;
    // this.ProductProfitablity.FGServGPBookLC =   this.ProductProfitablity.FGServGPBookLC;    
    //  alert(this.ProductProfitablity.FGServGPBookLC);
  setTimeout(() => {
    resolve(true);
  }, 1000);  
      

  }
  // setTimeout(() => {
  //   this.utility.BlockUIStop();
  // }, 1000);
});

}
OpenConsignee(): void {  
  let contactConsigneeParams: ContactConsigneeParams = new ContactConsigneeParams ();
  contactConsigneeParams.RefId=this.RefId;
  // contactConsigneeParams.RefId = 910411;
  contactConsigneeParams.AddressType = "C";
  contactConsigneeParams.AddressHeading = "Consignee Address";

  this.productsForConsignee = this.productArray
  .filter((pt)=>{ return pt.SelectedProduct != undefined});  
  this.productsForConsignee = this.productsForConsignee.map((pm)=> ({ 
    ProductCode:pm.SelectedProduct.productCode,
    ProductId:pm.SelectedProduct.productId,
    Quantity:0,
    SpraQuantity : pm.Quantity,
    RemainingQty: pm.Quantity
 }));
//ReviewedSpra added by rahul yadav on 11/05/2022 
  const dialogRef = this.dialog.open(SpraConsigneeComponent, {
    width: '90%',
    data: { ProfitTag : this.ProfitTag ,contactConsigneeParams: contactConsigneeParams ,products:this.productsForConsignee, spraConsigneeData: this.spraConsigneeData, ReviewedSpra: this.ReviewedSpra}
  });
  dialogRef.afterClosed().subscribe(result => {
    if (result && result.data != undefined) {
      this.spraConsigneeData = result.data.SpraConsigneeDataList;
      this.productsForConsignee = result.data.Products;
            // alert(JSON.stringify(result.data));
      this.Consignee.emit(this.spraConsigneeData);
    }
  });
}

// Getconsignee(){
//   return this.spraConsigneeData;
// }




}
